import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const TRACKING_ID = "UA-64288543-1"; // YOUR_OWN_TRACKING_ID // Google Analytics tracking ID

const RouteChangeTracker = (button?: boolean, buttonType?: string) => {
    const location = useLocation();
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!window.location.href.includes("localhost")) {
        ReactGA.initialize(TRACKING_ID);
        }
        setInitialized(true);
    }, []);

    useEffect(() => {
        if (initialized) {
            if (button && buttonType !== undefined) {
                ReactGA.event({
                    category: "Button",
                    action: location.pathname,
                    label: buttonType,
                });
            }
            ReactGA.set({ page: location.pathname, website: "new" });
            ReactGA.pageview(location.pathname + location.search);
        }
    }, [initialized, location]);
};

export default RouteChangeTracker